'use strict';

var cov_2025ghv8qe = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/companyTurnovers.js',
        hash = '89967c5e090e3eaf7a8607f7daf1025edde133e2',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/companyTurnovers.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 26,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 54
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 24,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 23,
                    column: 13
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 30
                },
                end: {
                    line: 21,
                    column: 17
                }
            },
            '5': {
                start: {
                    line: 22,
                    column: 16
                },
                end: {
                    line: 22,
                    column: 36
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 26,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'companyTurnovers',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 32
                    },
                    end: {
                        line: 25,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 15
                    },
                    end: {
                        line: 10,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 32
                    },
                    end: {
                        line: 24,
                        column: 9
                    }
                },
                line: 10
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 23,
                        column: 13
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 23,
                        column: 13
                    }
                }, {
                    start: {
                        line: 11,
                        column: 12
                    },
                    end: {
                        line: 23,
                        column: 13
                    }
                }],
                line: 11
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {
            '0': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2025ghv8qe.s[0]++;
(function () {
    'use strict';

    cov_2025ghv8qe.f[0]++;
    cov_2025ghv8qe.s[1]++;
    angular.module('app').filter('companyTurnovers', companyTurnovers);

    /* @ngInject */
    function companyTurnovers() {
        cov_2025ghv8qe.f[1]++;
        cov_2025ghv8qe.s[2]++;

        return function (input) {
            cov_2025ghv8qe.f[2]++;
            cov_2025ghv8qe.s[3]++;

            if (input) {
                cov_2025ghv8qe.b[0][0]++;

                var tiers = (cov_2025ghv8qe.s[4]++, {
                    A: '< 100K',
                    B: '100K-500K',
                    C: '500K-1M',
                    D: '1M-5M',
                    E: '5M-10M',
                    F: '10M-50M',
                    G: '50M-100M',
                    H: '> 100M'
                });
                cov_2025ghv8qe.s[5]++;
                return tiers[input];
            } else {
                cov_2025ghv8qe.b[0][1]++;
            }
        };
    }
})();